<template src="./Index.html">
</template>


<script>
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getDoctors");

  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.dispenseRequests.totalItems / this.filters.pageSize
      );
    },
    dispenseRequests() {
      return this.$store.state.dispenseRequests.dispenseRequests;
    },
    doctors() {

      return [
        { label: "الكل", value: 0 },
        ...this.$store.state.lookups.doctors];
    },
  },
  data() {
    return {
      permissions: this.$inventoryManagementPermissions.dispenseRequestsPermissions,
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      filters: {
        page: 1,
        pageSize: 10,
        fullName: null,
        phoneNo: null,
        orderNo: null,
        doctorId: 0,
      },
      headers: [
        { text: 'رقم الطلب ', value: 'orderNo' },
        { text: "اسم الحالة", value: 'fullName' },
        { text: "اسم الطبيب", value: 'doctorName' },
        { text: "تاريخ الموعد", value: "appointmentDate", sortable: false },
        { text: "حالة الطلب ", value: "status", sortable: false },

        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("dispenseRequests/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف الطلب";
          break;
        case "approval":
          this.dialogMessage = "هل انت متأكد من رغبتك اعتماد الطلب";
          break;
        case "reject":
          this.dialogMessage = "هل انت متأكد من رغبتك رفض الطلب ";
          break;

      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },
    handleClear() {
      this.filters.date = null;
    },
    confirmDialog() {
      this.$store.dispatch(`dispenseRequests/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>